import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Apps = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.8 3.8a.8.8 0 0 0-1.6 0v2.4h-2.4a.8.8 0 0 0 0 1.6h2.4v2.4a.8.8 0 0 0 1.6 0V7.8h2.4a.8.8 0 0 0 0-1.6h-2.4z'
          fill='currentColor'
        />
        <path
          d='M13.75 15.25a1.5 1.5 0 0 1 1.5-1.5h3.5a1.5 1.5 0 0 1 1.5 1.5v3.5a1.5 1.5 0 0 1-1.5 1.5h-3.5a1.5 1.5 0 0 1-1.5-1.5z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M3.75 15.25a1.5 1.5 0 0 1 1.5-1.5h3.5a1.5 1.5 0 0 1 1.5 1.5v3.5a1.5 1.5 0 0 1-1.5 1.5h-3.5a1.5 1.5 0 0 1-1.5-1.5z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M3.75 5.25a1.5 1.5 0 0 1 1.5-1.5h3.5a1.5 1.5 0 0 1 1.5 1.5v3.5a1.5 1.5 0 0 1-1.5 1.5h-3.5a1.5 1.5 0 0 1-1.5-1.5z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </>
    ) : (
      <>
        <path
          d='M17 3a.8.8 0 0 1 .8.8v2.4h2.4a.8.8 0 0 1 0 1.6h-2.4v2.4a.8.8 0 0 1-1.6 0V7.8h-2.4a.8.8 0 0 1 0-1.6h2.4V3.8A.8.8 0 0 1 17 3'
          fill='currentColor'
        />
        <path
          d='M15 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2z'
          fill='currentColor'
        />
        <path
          d='M3 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'
          fill='currentColor'
        />
        <path
          d='M5 3a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
